<div role="rowgroup">
    <div class="e-group-header" role="rowheader" (click)="toggleGroup()"
        (keydown)="groupHeaderKeyEvents($event)" tabindex="0">
        <h3>{{data.industry}}</h3>
        <div class="e-cell-borders">
            <span></span>
            <span></span>
        </div>
    </div>
    <div class="e-group-rows" [class.e-collapsed]="!isExpanded" (keydown)="tableRowKeyEvents($event)">
        <ng-container *ngIf="isExpanded">
            <via-sku-time-series-table-row
                *ngFor="let skuData of data.skus;let i = index;trackBy: trackByMethod"
                [data]="skuData"
                [selectedSortType]="selectedSortType"
                [isShowingAllPrices]="isShowingAllPrices"
                [showRegularPrice]="showRegularPrice"
                [timeSeriesIndices]="timeSeriesIndices"
                [imageSasParams]="imageSasParams"
            ></via-sku-time-series-table-row>
        </ng-container>
    </div>
</div>
